export const ModalAction = {
    Close: "modal.close",
    CloseLegacy: "close-modal", //Legacy notation, keep for
};
